import * as React from 'react';

import { BaseComponent } from './BaseComponent';

interface ToggleGroupProps {
    title: string;
}

interface ToggleGroupState {
    open: boolean;
}

export class ToggleGroup extends BaseComponent<ToggleGroupProps, ToggleGroupState> {
    public componentWillMount(): void {
        this.setState({
            open: true
        });
    }

    public render(): JSX.Element {
        return (
            <div className={'long-button-group with-title' + (this.state.open ? ' active' : '')}>
                <div
                    className={'core-config' + (this.state.open ? ' active' : '')}
                    onClick={this.toggle}
                >
                    <div className="core-config-header">{this.props.title}</div>
                </div>
                {this.state.open ? this.props.children : null}
            </div>
        );
    }

    protected toggle = (): void => {
        this.setState({
            open: !this.state.open
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToggleGroup.tsx